import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";

import { Performance } from './performance.model';
import { PerformanceService } from './performance.service';
import { AlertService } from '../../util/alert/alert.service';
import { SharedService } from '../../home/shared.service';
import { UserService } from '../../user/user.service';

import { PerformanceTagService } from '../../tag/performancetag/performancetag.service';
import { TagInputModule } from 'ngx-chips';
import { NoWhitespaceDirective } from "../../util/validator/nowhitespace.directive"
import { SanitizationService } from '../../sanitizer.service';
@Component({
	selector: 'app-editperformance',
	templateUrl: './editperformance.component.html'
})
export class EditPerformanceComponent implements OnInit {

	public editPerformance: Performance;
	editPerformanceForm: FormGroup;

	public selectedTags = [];
	public activeTagList = [];
	items = [];

	constructor(private sharedService: SharedService,
		private alertService: AlertService,
		private performanceService: PerformanceService,
		private performanceTagService: PerformanceTagService,
		private userService: UserService,
		private sanitizer: SanitizationService
	) {
		if (!userService.isValidLoggedIn()) {
			userService.redirectToLoginScreen();
		}

		this.editPerformance = performanceService.getSelectedPerformanceForEdit();
		this.editPerformance.tagList.forEach(tag => {
			let item = { value: tag.value, id: tag.id }
			this.items.push(item)
		});
	}

	ngOnInit() {
		//Called after the constructor, initializing input properties, and the first call to ngOnChanges.
		//Add 'implements OnInit' to the class.

		this.loadActivePerformanceTags();
		this.editPerformanceForm = new FormGroup({
			id: new FormControl(this.editPerformance.id, Validators.required),
			performance: new FormControl(this.editPerformance.text, Validators.required),
			performanceTag: new FormControl('')
		});
	}

	//navigate to all performance component
	selectedComponentItem(itemName: string) {
		this.sharedService.change(itemName);
	}


	onSubmit() {
		if (this.checkNeedtoUpdatePerformance()) {
			//console.log('[checkNeedtoUpdatePerformance()] (items)' + JSON.stringify(this.items).toString());
			//console.log('[checkNeedtoUpdatePerformance()] (tagList)' + JSON.stringify(this.editPerformance.tagList).toString());

			let tempPerformance = new Performance(this.editPerformance.id, this.sanitizer.sanitize(this.editPerformanceForm.value.performance));
			tempPerformance.tagList = this.items;
			this.performanceService.updatePerformanceByPerformanceId(tempPerformance)
				.subscribe(
				data => {
					this.alertService.clear();
					this.alertService.success(data.message);
					this.editPerformance.text = this.sanitizer.sanitize(this.editPerformanceForm.value.performance);
					this.editPerformance.tagList = []
					this.items.forEach(tag => {
						let item = { value: tag.value, id: tag.id }
						this.editPerformance.tagList.push(item)
					});
					//console.log('[onSubmit] (this.items) ' + JSON.stringify(this.items).toString());
					//console.log('[onSubmit] (this.editPerformance.tagList) ' + JSON.stringify(this.editPerformance.tagList).toString());
				},
				error => {
					this.alertService.clear();
					let err = error.json();
					this.alertService.handleError(err);
				}
				);
		} else {
			//no need to update performance
			this.alertService.clear();
			this.alertService.error('There are no changes to update.');
		}
	}

	checkNeedtoUpdatePerformance(): boolean {
		if (this.editPerformance.text != this.editPerformanceForm.value.performance) {
			return true;
		} else if (this.compairArrayForChanges(this.editPerformance.tagList, this.items)) {
			return true;
		} else {
			return false;
		}
	}

	public compairArrayForChanges(arrayOld: any, arrayNew: any): boolean {
		//console.log('[compairArrayForChanges] (arrayOld) ' + JSON.stringify(arrayOld).toString())
		//console.log('[compairArrayForChanges] (arrayNew) ' + JSON.stringify(arrayNew).toString())
		let haveChanges: boolean = false
		if (arrayOld.length != arrayNew.length) {
			haveChanges = true
		} else {
			let missing = []
			arrayNew.forEach(newItem => {
				if (!(this.isValueExists(arrayOld, newItem.value))) {
					missing.push(newItem)
				}
			});
			if (missing.length == 0) {
				haveChanges = false
			} else {
				haveChanges = true
			}
		}
		return haveChanges;
	}

	public isValueExists(list: any[], value: string): boolean {
		var isExists = false;
		list.forEach(a => {
			if (a.value == value) {
				isExists = true;
			}
		});
		return isExists;
	}

	public loadActivePerformanceTags() {
		this.performanceTagService.getActivePerformanceTags()
			.subscribe(
			data => {
				//console.log('[loadActivePerformanceTags] ' + JSON.stringify(data).toString());
				this.activeTagList = []
				data.ptagList.forEach(element => {
					let item = { value: element.Description, id: element.Id }
					this.activeTagList.push(item);
				});
			},
			error => {
				this.alertService.clear();
				let err = error.json();
				this.alertService.handleError(err);
			}
			);
	}

	public addTags(event: any) {
		this.items.push(event);
		// console.log('[addTags] (this.items) ' + JSON.stringify(this.items).toString());
		// console.log('[addTags] (this.editPerformance.tagList) ' + JSON.stringify(this.editPerformance.tagList).toString());
	};

	public removeTags(event: any) {
		//console.log('[removeTags]' + JSON.stringify(event).toString());
		this.items = this.items.filter(tag => tag.id !== event.id);
		// console.log('[removeTags] (this.items) ' + JSON.stringify(this.items).toString());
		// console.log('[removeTags] (this.editPerformance.tagList) ' + JSON.stringify(this.editPerformance.tagList).toString());
	};
}
